/**
 * Todo status
 * 
 * @var const status
 */
export const status = {
    opened: 'error',pending: 'warning',closed: 'success'
};